import { useSuspenseQuery } from "@tanstack/react-query";
import type { SecaoEmpresa } from "@/components/casca/Ajustes";
import { FormEmpresa } from "@/components/empresa/FormEmpresa";
import { empresaQuery } from "../consultas";

/** O cadastro da clínica e o assistente — um formulário que nasce do que está salvo, mostrado uma seção por vez. */
export function Empresa({ secao }: { secao: SecaoEmpresa }) {
  const { data } = useSuspenseQuery(empresaQuery());
  return <FormEmpresa secao={secao} inicial={data.inicial} agenteInicial={data.agente} constituicaoInicial={data.constituicao} />;
}
